module.exports = __webpack_public_path__ + "static/M3-05 small-image-aab3a740b018ac979711727bcd0072db.png";